import React from 'react';
import FontsMapper from "../services/FontsMapper";
import {calculateGridLines, convertCmToPx, convertMMtoPxWithScaling} from "../services/helpers";
const fontsMapper = new FontsMapper();
const PdfForStonemasons = ({
                               pdfItemsToRender,
                               data,
                               margin,
                               scale,
                               letterSpacing,
                               workingSize,
                               showGrid,
}) => {
    // Calculate grid lines for PDF (accounting for 0.75 scaling factor)
    const gridLines = workingSize?.widthCm && workingSize?.heightCm && data.gridSpacingCm
        ? calculateGridLines(workingSize.widthCm, workingSize.heightCm, data.gridSpacingCm)
        : { verticalLines: [], horizontalLines: [] };
    const prepareHtml = (section , index) => {
        const html = `<style>
                           #section-${index} p, 
                           #section-${index} span {
                                display: flex;
                                align-items: center;
                                justify-content: flex-start;
                                height: ${section.fontSizeValuePx}px;
                                min-height: 100%;
                                font-size: ${(section.fontSizeValuePx * 1.6 * 0.75)}px;
                                text-align: ${section.textAlign};
                                font-family: ${fontsMapper.fonts[data.selectedFontObject.woocommerce_product_id].clr[data.selectedFontSizeObject.slug].name};
                                letter-spacing: ${letterSpacing}px;
                                line-height : 1;
                                width : auto;
                            }
                             
                        </style>
                        ${section.value}
                        `
        return html;
    }
    return (
    <html lang="pl-PL">
    <body style={{
        padding: 0,
        margin: 0,
        position: 'relative',
        width: '100%',
        height: '100%',
    }}>
    {/* Grid overlay */}
    {showGrid && (
        <>
            {/* Vertical grid lines */}
            {gridLines.verticalLines.map((position, index) => (
                <div
                    key={`v-${index}`}
                    style={{
                        position: 'absolute',
                        left: `${(position * 0.75 )}px`,
                        top: 0,
                        display : 'block',
                        width: '1px',
                        height: convertCmToPx(workingSize.heightCm) * 0.75,
                        backgroundColor: 'rgba(204, 204, 204, 0.5)',
                        zIndex: 0,
                    }}
                />
            ))}
             {/*Horizontal grid lines*/}
            {gridLines.horizontalLines.map((position, index) => (
                <div
                    key={`h-${index}`}
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: `${(position * 0.75 )}px`,
                        width: convertCmToPx(workingSize.widthCm) * 0.75,
                        height: '1px',
                        backgroundColor: 'rgba(204, 204, 204, 0.5)',
                        zIndex: 0,
                    }}
                />
            ))}
        </>
    )}
    {pdfItemsToRender.map((section, index) => (
        <div
            id={`section-${index}`}
            style={{
                position: 'absolute',
                top: (((section.position.y / 0.5) - margin) * 0.75),
                left: ((section.position.x / 0.5) - margin) * 0.75,
                display: 'flex',
                flexDirection: 'row',
                alignItems : 'center',
                zIndex: 10,
                height: `${section.fontSizeValuePx}px`,
            }}
            key={index}
            dangerouslySetInnerHTML={{__html: prepareHtml(section, index)}}
        />
    ))}
    </body>
    </html>
    );
};

export default PdfForStonemasons;
